<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
*{
  box-sizing: border-box;
  -webkit-overflow-scrolling : touch;
}
html, body{
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
}
a{
  text-decoration: none;
  color: inherit;
}
footer a:hover {
  color: aquamarine;
}
div, ul{
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
li{
  list-style-type:none;
}
p{
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
</style>
